import moment from "moment-timezone";
export default {
    filters: {
      friendlyTime: function (value) {
        let time = moment.utc(value, "HH:mm:ss").format("h:mm a")
        return time
    }
      }
};
